'use client';

import { sendBackofficeEvent } from '@/components/newRelic';
import { showToast } from '@/redux/navigationSlice';
import { VIEWED_DOCUMENTS_KEY } from '@/utils/constants';
import { backofficeJWT, login, loginParams, type loginResponse } from '@repo/backoffice-api';
import { Login } from '@repo/ui';
import { deleteClientCookie, getClientCookie, parseJwt, setClientCookie } from '@repo/utils';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export default function Page(): React.JSX.Element {
  const router = useRouter();
  const dispatch = useDispatch();
  const forceMock = process.env.NEXT_PUBLIC_BACKOFFICE_API_FORCEMOCK === 'true';
  const mockExpire = new Date(Date.now() + 12 * 60 * 60 * 1000).toUTCString();

  useEffect(() => {
    deleteClientCookie('token-backoffice');
    deleteClientCookie(`${VIEWED_DOCUMENTS_KEY}:${getClientCookie('backoffice-user')}`);
    deleteClientCookie('backoffice-user');
  }, []);

  return (
    <Login<loginResponse, loginParams>
      credentialType="username"
      connector={login}
      callback={(response) => {
        const decodedToken = parseJwt(response.jwt) as backofficeJWT;
        const expireDate = forceMock ? mockExpire : new Date(decodedToken?.exp * 1000).toUTCString();
        setClientCookie('token-backoffice', response.jwt, expireDate);
        setClientCookie('backoffice-user', decodedToken?.sub, new Date(Date.now() + 24 * 60 * 60 * 1000).toUTCString());
        sendBackofficeEvent({
          type: 'interaction',
          subtype: 'login',
          data: {
            page: 'login',
            username: decodedToken?.sub,
            roles: decodedToken?.roles,
            actions: decodedToken?.actions,
          },
        });
        router.push('/prospects');
      }}
      onError={() => dispatch(showToast({ kind: 'error', text: 'Usuario y/o contraseña incorrectos' }))}
    />
  );
}
